import uuidV4 from 'uuid/v4';

function uuid() {
    return uuidV4();
}

function isArray(val) {
    return Array.isArray(val);
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(val) {
    return (
        val !== null &&
        typeof val === 'object' &&
        !isArray(val) &&
        !isFunction(val)
    );
}

function isString(val) {
    return typeof val === 'string';
}

function isNumber(val) {
    return typeof val === 'number';
}

function isBoolean(val) {
    return typeof val === 'boolean';
}

function isEmptyObject(val) {
    return isObject(val) && Object.keys(val).length === 0;
}

function isNil(val) {
    return typeof val === 'undefined' || val === null;
}

function nvl(val, alt) {
    return isNil(val) ? alt : val;
}

function trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

function splitWord(str) {
    return trim(str).split(/\s+/);
}

let lastId = 0;
function stamp(obj) {
    obj._navi_map_id = obj._navi_map_id || ++lastId;
    return obj._navi_map_id;
}

/**
 * 深度复制方法
 * @param {ant} val 要克隆的内容
 */
function clone(val) {
    let ret = val;
    if (isArray(val)) {
        ret = val.map(it => clone(it));
    } else if (isObject(val)) {
        if (isFunction(val.clone)) {
            ret = val.clone();
        } else {
            ret = {};
            for (const [k, v] of Object.entries(val)) {
                ret[k] = clone(v);
            }
        }
    }

    return ret;
}

/**
 * 防抖动包装函数
 * @param {function} fn  要防抖的函数
 * @param {number} delay 延迟时间，单位毫秒
 * @returns {function} 防抖包装后的函数
 */
function debounce(fn, delay = 0) {
    const context = this;
    let timer = null;

    return (...rest) => {
        if (timer) {
            clearTimeout(timer);

            timer = setTimeout(() => {
                fn.apply(context, rest);
            }, delay);
        } else {
            timer = setTimeout(() => {
                fn.apply(context, rest);
            }, delay);
        }
    };
}

/**
 * 返回promise的防抖包装函数
 * @param {function} fn  要防抖的函数
 * @param {number} delay 延迟时间，单位毫秒
 * @returns {function} 防抖包装后的函数，该函数返回promise
 */
function debounceP(context, fn, delay = 0) {
    let timer = null;
    let resolve;
    let reject;
    const p = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });

    return (...args) => {
        if (timer) {
            clearTimeout(timer);

            timer = setTimeout(() => {
                Promise.try(() => fn.apply(context, args))
                    .then(rest => {
                        resolve(rest);
                    })
                    .catch(e => {
                        reject(e);
                    });
            }, delay);
        } else {
            timer = setTimeout(() => {
                Promise.try(() => fn.apply(context, args))
                    .then(rest => {
                        resolve(rest);
                    })
                    .catch(e => {
                        reject(e);
                    });
            }, delay);
        }

        return p;
    };
}

/**
 * 节流包装函数
 * @param {function} fn  要节流的函数
 * @param {number} delay 延迟时间，单位毫秒
 * @returns {function}   节流包装后的函数
 */
function throttle(fn, delay = 0) {
    const context = this;
    let timer = null;
    let previous = new Date();

    return (...rest) => {
        const now = new Date();
        const remaining = now - previous;

        if (remaining >= delay) {
            if (timer) {
                clearTimeout(timer);
            }

            fn.apply(context, rest);
            previous = now;
        } else {
            if (!timer) {
                timer = setTimeout(() => {
                    fn.apply(context, rest);
                    previous = new Date();
                }, delay - remaining);
            }
        }
    };
}

export default {
    uuid,
    isArray,
    isFunction,
    isBoolean,
    isObject,
    isString,
    isNumber,
    isEmptyObject,
    isNil,
    nvl,
    clone,
    debounce,
    debounceP,
    throttle,
    trim,
    splitWord,
    stamp
};
